( function( ) {
	'use strict';

	class BrookshireRouter {
		constructor() {
			this.currentUrl = "";
		}

		navigateTo( destination, initial ) {
			console.log( 'Routing to', destination, initial?'as the first hit':'' );
			// remove any leading or trailing /
			destination = destination.replaceAll("/","");

			// calculate path from current url to destination
			var steps = this.calculatePath(this.currentUrl, destination);
			console.log("Calculated steps to get to", destination, steps);

			// for each step
			steps.forEach(step => {
				// push the window state
				window.history.pushState({path: step}, "Brookshire Experience", "/"+step);
				// play the transition (which will animate unless it's the initial load)
			});
		}

		navigateBack() {
			// split the current path on '-'
			var pathComponents = currentUrl.split( '-' );

			if( 1 < pathComponents.length ) {
				// take all but the last element and navigate to it
				pathComponents.pop();
				this.navigateTo( pathComponents.join( '-' ) );
			} else {
				this.navigateTo( '' );
			}
		}

		calculatePath( from, to ) {
			if(from === to) {
				return [];
			}

			// get the path to both items
			var fromArray = this.buildPath(from.split("-"));
			var toArray = this.buildPath(to.split("-"));

			// eliminate common prefixes
			while(fromArray.length > 0 && toArray.length > 0 && fromArray[0] === toArray[0]) {
				fromArray.shift();
				toArray.shift();
			}
			console.log("navigating from ", fromArray, "to", toArray);

			// walk backwards up the from, then forwards down the to
			fromArray.reverse().push(...toArray);
			return fromArray;
		}

		buildPath( pathParts ) {
			var steps = [];
			pathParts.forEach(p => {
				steps.push(pathParts.slice(0,steps.length+1).join("-"));
			});
			console.log("Steps in ",pathParts,"are",steps);

			if(steps[0] !== "") {
				// keep the empty element at the front
				steps.unshift("");
			}
			return steps;
		}

	}


	window.router = new BrookshireRouter();
	document.onreadystatechange = function () {
		if ( 'interactive' === document.readyState ) {
			window.router.navigateTo( document.location.pathname, true );
		}
	};
	window.onpopstate = function( e ){
		if( e.state ){
			window.router.navigateTo( e.state.path );
			// or navigateBack()?
		}
	};

} )();
